// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const CTA_RETURN_BACK = "Vr\u00e1\u0165 sa sp\u00e4\u0165";
